import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input } from 'reactstrap';

export default class FinancialInterests extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Interest</Label>
                            <Input name='interest' required maxLength="100" value={this.props.item.interest || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Description</Label>
                            <Input type="textarea" name='description' required maxLength="1000" value={this.props.item.description || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}